export enum TimeLapse {
  hours = 'Hours',
  days = 'Days',
  months = 'Months',
  years = 'Years'
}